import createStore from '../../../redux/factories/crud/crudFactory';

import {actions as userActions, userReducers} from './user.reducers';
import {actions as groupActions, groupReducers} from './group.reducers';
import {userCoreSaga} from './user.saga';
import {groupCoreSaga} from './group.saga';

export const user = Object.assign(
    createStore('api/v2/users'),
    {
        userActions,
        userReducers,
        userCoreSaga,
    }
);

export const group = Object.assign(
    createStore('api/v2/groups'),
    {
        groupActions,
        groupReducers,
        groupCoreSaga,
    }
);

export const folder = createStore('document-service/api/v2/folders');
export {groupActions, userActions};
